import { render, staticRenderFns } from "./updateWeb.vue?vue&type=template&id=70b90570"
import script from "./updateWeb.vue?vue&type=script&lang=js"
export * from "./updateWeb.vue?vue&type=script&lang=js"
import style0 from "./updateWeb.vue?vue&type=style&index=0&id=70b90570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports